/**
 * Wire module keys from familyhub-backend MODULE_REGISTRY (#172).
 * Use these values for POST /access-requests/ and pending-request matching.
 */
export const BACKEND_MODULE_KEYS = {
  apartments: "apartments",
  payments: "payments",
  budget: "budget",
  documents: "documents",
  tasks: "tasks",
  reminders: "reminders",
  knowledge: "knowledge",
  family: "family",
  aiChat: "ai-chat",
  integrations: "integrations",
} as const;

export type BackendModuleKey = (typeof BACKEND_MODULE_KEYS)[keyof typeof BACKEND_MODULE_KEYS];

export const REQUESTABLE_BACKEND_MODULE_KEYS: readonly BackendModuleKey[] = [
  BACKEND_MODULE_KEYS.apartments,
  BACKEND_MODULE_KEYS.payments,
  BACKEND_MODULE_KEYS.budget,
  BACKEND_MODULE_KEYS.documents,
  BACKEND_MODULE_KEYS.tasks,
  BACKEND_MODULE_KEYS.reminders,
  BACKEND_MODULE_KEYS.knowledge,
  BACKEND_MODULE_KEYS.family,
  BACKEND_MODULE_KEYS.aiChat,
] as const;

const BACKEND_KEY_SET = new Set<string>(Object.values(BACKEND_MODULE_KEYS));

export function isBackendModuleKey(key: string): key is BackendModuleKey {
  return BACKEND_KEY_SET.has(key);
}

/** Internal catalog / gate id (e.g. ai_chat) from API key. */
export function catalogIdFromBackendKey(key: string): string {
  if (key === BACKEND_MODULE_KEYS.aiChat) {
    return "ai_chat";
  }
  return key;
}

/** API module_key from internal catalog id or gate id. */
export function toBackendModuleKey(id: string): BackendModuleKey | null {
  if (id === "ai_chat") {
    return BACKEND_MODULE_KEYS.aiChat;
  }
  if (isBackendModuleKey(id)) {
    return id;
  }
  return null;
}
